import BuyButton from 'map/components/actionButton/BuyButton'
import { BUTTON_TYPES, UnbookableButton } from 'map/components/actionButton/UnbookableButton'
const ActionBtn = ({
    canBuy,
    opngo,
    externalSeasonTicketUrl,
    rate,
    bookingUrl,
    buyLabel,
    phone,
    unbookableBtnType,
    carParkUrl,
    unbookableBtnUrl,
    monthlyParkingUrl,
    redirectToMonthlyParkingFlow,
}) => {
    if (canBuy || opngo || !!externalSeasonTicketUrl) {
        return (
            <BuyButton
                externalSeasonTicketUrl={externalSeasonTicketUrl}
                opngo={opngo}
                rate={rate}
                bookingUrl={redirectToMonthlyParkingFlow ? monthlyParkingUrl : bookingUrl}
                buyLabel={buyLabel}
                monthlyParkingUrl={monthlyParkingUrl}
            />
        )
    } else if (!canBuy && unbookableBtnType && unbookableBtnType !== BUTTON_TYPES.unassigned) {
        return (
            <UnbookableButton
                phone={phone}
                unbookableBtnType={unbookableBtnType}
                unbookableBtnUrl={unbookableBtnUrl}
                carParkUrl={carParkUrl}
            />
        )
    }

    return null
}

export default ActionBtn
